import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCopilotStore } from '../stores/useCopilotStore';

/**
 * Open an earlier Copilot conversation, or start a new one — the same way
 * from the sidebar's list and from the thread bar's dropdown.
 */
export function useCopilotThreadActions() {
  const navigate = useNavigate();

  const openThread = useCallback(
    (threadId: string, title: string | null) => {
      const store = useCopilotStore.getState();
      if (store.threadId === threadId) return;
      store.resetSession();
      store.setThreadId(threadId);
      store.setThreadTitle(title);
      navigate(`/copilot/${threadId}`);
    },
    [navigate],
  );

  const newChat = useCallback(() => {
    const id = crypto.randomUUID();
    const store = useCopilotStore.getState();
    store.resetSession();
    store.setThreadId(id);
    navigate(`/copilot/${id}`);
  }, [navigate]);

  return { openThread, newChat };
}
